import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RoutesSwitch from '../../../components/flights/routesSwitch/RoutesSwitch';
import TripsSwitch from '../../../components/flights/tripsSwitch/TripsSwitch';
import FlightsFormMobile from '../../../components/flights/flightsForm/FlightsFormMobile';
import PassengersCounterDialog from './passengersCounter/PassengersCounterDialog';
import Constants from '../../../model/AppConfiguration';
import Dictionary from '../../../model/Dictionary';
import FlightsScreenController from '../FlightsScreenController';
import CalendarDialog from './calendar/CalendarDialog';
import './FlightsMobile.css';
import moment from 'moment';

export default class FlightsMobileScreen extends Component {
  static propTypes = {
    selectedRoute: PropTypes.object,
    flights: PropTypes.arrayOf(PropTypes.object),
    toggleRoutes: PropTypes.func,
    selectedTrip: PropTypes.object,
    toggleTrips: PropTypes.func,
    submitFlights: PropTypes.func,
  };

  constructor (props) {
    super(props);

    let flights = props.flights;
    let firstFlight =
      flights && flights.length ? flights[ 0 ] : { adults: 0, infants: 0, date: moment(new Date()) };
    let secondFlight =
      flights && flights.length ?
        flights[ 1 ] :
        { adults: 0, infants: 0, date: moment(moment(new Date())).add(5, 'days') };
    this.state = {
      flights: flights || [],
      adultsDeparture: firstFlight.adults,
      infantsDeparture: firstFlight.infants,
      adultsArrival: secondFlight ? secondFlight.adults : 0,
      infantsArrival: secondFlight ? secondFlight.infants : 0,
      passengersFormOpen: false,
      selectedPassengersTab: 0,
      calendarOpen: false,
      selectedCalendarTab: 0,
      selectedFlight: {},
    };

    this.handlePassengersTabChange = FlightsScreenController.handlePassengersTabChange.bind(this);
    this.handleCalendarTabChange = FlightsScreenController.handleCalendarTabChange.bind(this);
    this.changePassengerNumber = FlightsScreenController.changePassengerNumber.bind(this);
    this.handleClickOpen = FlightsScreenController.handleClickOpen.bind(this);
    this.handleClose = FlightsScreenController.handleClose.bind(this);
    this.selectDate = FlightsScreenController.selectDate.bind(this);
    this.findRouteById = FlightsScreenController.findRouteById.bind(this);
    this.openCalendar = FlightsScreenController.openCalendar.bind(this);
    this.closeCalendar = FlightsScreenController.closeCalendar.bind(this);
    this.getArrivalDate = FlightsScreenController.getArrivalDate.bind(this);
    this.updateFlightsRoute = FlightsScreenController.updateFlightsRoute.bind(this);
  }

  submitData = step => {
    let general = Object.assign({}, this.props.general);
    general.trip = this.props.selectedTrip;
    this.props.submitFlights(Constants.REQUEST.FLIGHTS, general, this.state.flights, step);
  };

  componentWillReceiveProps (props) {
    const { selectedRoute } = props;
    if (props.flights && this.props.flights && props.flights.length > this.props.flights.length) {
      this.setState({ flights: props.flights });
    }

    if (selectedRoute !== this.props.selectedRoute) {
      this.updateFlightsRoute(selectedRoute, this.props.selectedRoute);
    }
  }

  render () {
    const { selectedRoute, toggleRoutes, selectedTrip, toggleTrips } = this.props;
    const {
      flights,
      passengersFormOpen,
      selectedPassengersTab,
      calendarOpen,
      selectedCalendarTab,
      departureFlight,
      arrivalFlight,
    } = this.state;

    return (
      <div className='container' id='mobile-container'>
        <h1>{Dictionary.flights.title}</h1>
        <RoutesSwitch selectedRoute={selectedRoute} toggleRoutes={toggleRoutes} />
        <TripsSwitch selectedTrip={selectedTrip} toggleTrips={toggleTrips} />

        {flights.map((flight, index) => {
          if (selectedTrip && selectedTrip.id === Constants.flights.oneWay && index > 0) {
            return null;
          }
          return (
            <FlightsFormMobile
              key={`flights-form-mobile-${flight.id}-${index}`}
              location={this.findRouteById(flight.routeId).departure}
              adults={flight.adults ? parseInt(flight.adults, 10) : 0}
              infants={flight.infants ? parseInt(flight.infants, 10) : 0}
              date={flight.date}
              openCalendar={() => this.openCalendar(index)}
              handleClickOpen={() => this.handleClickOpen(index)}
            />
          );
        })}

        <PassengersCounterDialog
          selectedRoute={selectedRoute}
          selectedTrip={selectedTrip}
          flights={flights}
          changePassengerNumber={this.changePassengerNumber}
          open={passengersFormOpen}
          handleClose={this.handleClose}
          handleTabChange={this.handlePassengersTabChange}
          selectedTab={selectedPassengersTab}
        />

        <CalendarDialog
          selectedRoute={selectedRoute}
          selectedTrip={selectedTrip}
          departureFlight={departureFlight}
          arrivalFlight={arrivalFlight}
          open={calendarOpen}
          flights={flights}
          selectDate={this.selectDate}
          handleClose={this.closeCalendar}
          handleTabChange={this.handleCalendarTabChange}
          selectedTab={selectedCalendarTab}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/FlightsMobileScreen.js